import moment from "moment/moment.js";
import Swiper, { Navigation, Pagination } from 'swiper';

const LABELS = [
    { id: "car_motor",        text: "Auto & Motor", icon: 'Auto-Motor' },
    { id: "leisure_culture",  text: "Freizeit, Kultur & Vereine", icon: 'Freizeit-Kultur' },
    { id: "accomodation",     text: "Gastronomie & Übernachtung", icon: 'Gastronomie-Uebernachtung' },
    { id: "service",          text: "Dienstleistungen", icon: 'Dienstleistungen' },
    { id: "wellness_fitness", text: "Wellness, Fitness & Beauty", icon: 'Wellness-Fitness' },
    { id: "health",           text: "Gesundheit", icon: 'Gesundheit' },
    { id: "building_garden",  text: "Bauen, Wohnen & Garten", icon: 'Bauen-Wohnen-Garten' },
    { id: "shopping",         text: "Einkaufen", icon: 'Einkaufen' },
    { id: "infrastructure",   text: "Infrastruktur, Kirche & Nützliches", icon: 'Infrastruktur-Nuetzliches' },
    { id: "all",              text: "Sonstiges", icon: 'Infrastruktur-Nuetzliches' }
]
const regexExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi;
window.scrollLoad = true;
window.page_num = 1;

$(document).ready(function() {
  $(window).scroll(async function() {
    if ($('#poi_loaded_list').length != 1) { return; }

    if (window.scrollLoad && (window.location.href.indexOf("entdecken") > -1) && $(window).scrollTop() >= $(document).height() - $(window).height() - 300) {
      // valid
    } else { return; }

    const skeletonItem = `<li class="poi-skeleton-item"><div class="row mt-3"><div class="col-12"><div class="row pt-2"><div class="col-2 pe-0 ps-0 ps-lg-3"><div class="poi-thumb-wrap"></div></div><div class="col-10"><div class="poi-skel-line poi-skel-line--title"></div><div class="poi-skel-line poi-skel-line--address"></div><div class="poi-skel-line poi-skel-line--badge"></div></div></div><hr class="mb-0 border-light"></div></div></li>`;
    $("#poi_loaded_list").append(`<div id="list_loader">${skeletonItem}${skeletonItem}${skeletonItem}</div>`);
    let category = window.location.pathname.split("/")[(window.location.pathname.split("/").length - 1)];
    window.scrollLoad = false;
    window.page_num = window.page_num + 1;
    let sort_ = $("#sort_by_name").is(':checked') ? "name": ''
    let suggestions = await getPoiList(window.page_num, category, sort_);

    $.each(suggestions.data, function(key, value) {
      let is_premium = value.company.is_premium == true ||
                       value.company.is_premium.toString() == 'true';
      let is_premium_module_offer = moment(new Date()).isBetween(new Date(value['company']['premium_module_offer_from']), new Date(value['company']['premium_module_offer_to']));
      $("#poi_loaded_list").append(`<li data-link="/entdecken/${value["category_id"]}/${value["id"]}" data-title="${value["company"]["name"]}" data-coordinates='${JSON.stringify(value.common.location.coordinates)}'><a class="text-decoration-none text-dark" href="/entdecken/${category}/${value.id}"><div class="row mt-3">
      <div class="col-12">
      <div class="row pt-2">
      <div class="col-2 pe-0 ps-0 ps-lg-3">` + `${value.company.logo ? `<div class="poi-thumb-wrap"><img class="w-100 img-thumbnail" src="${value.company.logo}" onload="this.classList.add('poi-img-loaded')"></div>` : `<div class="bg-default-gray w-100 h-100 d-flex justify-content-center align-items-center br-5">
      <div class="fs-1 icon-${LABELS.find(x => x.id === value["category_id"]).icon}"></div>
      </div>`}
      `+ `
      </div>
      <div class="${is_premium ? 'col-10' : 'col-10'}">
      <h6>${value.company.name}</h6>
      <p class="fs-small">${value["common"]["location"]["address"] + ", " + value["common"]["location"]["zip"] + " " + value["common"]["location"]["city"]}</p>
      <div class="badge bg-common-black fw-normal">~${value["common"]["location"]["distance"]} km</div>
      <div class="badge bg-default-gray-light common-text-black fw-normal">${value["category_id"] != "all" ? LABELS.find(x => x.id === value["category_id"]).text : "in allen Kategorien "}</div>
      ${is_premium ? `<div class="badge bg-primary common-text-black fw-normal">Premiumeintrag</div>${is_premium_module_offer ? `<img class="ms-1" style="width: 19px; height: 19px; border-radius: 2px;" src="/icons/button-premium-angebot.svg">`: ''}` : ''}
      </div>
      </div>
      <hr class="mb-0 border-light">
      </div>
      </div>
      </a></li>`);
    });

    if (suggestions.data.length < 1) {
      window.scrollLoad = false;
      $("#poi_loaded_list").append(`<p class="fs-small text-black-50 text-center mt-3">Alle Ergebnisse gesehen</p>`)
    } else {
      window.scrollLoad = true;
    }
    $("#list_loader").remove();
  });
});

const fetchCategoriesByRadius = (radius) => {
  const url = new URL(window.location.href);
  if (radius) {
    url.searchParams.set('radius', radius);
  } else {
    url.searchParams.delete('radius');
  }

  return fetch(url.toString(), {
    headers: {
      Accept: 'text/vnd.turbo-stream.html',
    },
    credentials: 'same-origin',
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Radius update failed');
      }
      return response.text();
    })
    .then((stream) => {
      if (typeof Turbo !== 'undefined' && Turbo.renderStreamMessage) {
        Turbo.renderStreamMessage(stream);
        window.history.replaceState({}, '', url.toString());
      }
    })
    .catch((error) => {
      console.warn('Unable to update radius', error);
    });
};

const initRadiusSelector = () => {
  $(document).off('change.radiusSelector')
    .on('change.radiusSelector', '[data-radius-selector]', function handleRadiusChange() {
      fetchCategoriesByRadius($(this).val());
    });
};

const initAutoSubmitFields = () => {
  $(document).off('change.autoSubmitFields')
    .on('change.autoSubmitFields', '[data-submit-on-change]', function handleAutoSubmit() {
      const $form = $(this).closest('form');
      if ($form.length) {
        $form.trigger('submit');
      }
    });
};

$(document).on('turbo:before-stream-render', function () {
  window.scrollLoad = true;
  window.page_num = 1;
});
$(document).on('turbo:load', function () {
  initRadiusSelector();
  initAutoSubmitFields();
  let offer_data = [] ;
  let offer_html = '';
  $("#story_container li").on("click", async function() {
  offer_html = '';
  offer_data = '';
  offer_data = $(this).data( "offer" );
  await offer_data.forEach(function(item) {
  let offer_percentage =
    item['offer_has_discount'] ? (`<div class="p-absolute">
       <div class="price-content" style="padding-left: 2em">
          <div class="z10000">
             <p>""</p>
          </div>
       </div>
    </div>
    <p class="p-absolute" style="margin-top: 25px; margin-left: 15px; color: white; font-weight: bold;">- ${Math.round(item['offer_discount_percent'])}%</p>`): '';
  let offer_price = item['offer_has_discount'] ? item['offer_discount_price'] : item['offer_price'];
  let price_text = item['offer_has_discount'] ? `anstatt ${item['offer_price']} € inkl. MwSt.` : "inkl. MwSt.";
  let offer_link = item['offer_link'] ? (regexExp.test(item['offer_link'])? `<div class="row mt-3">
     <div class="col-md-12 d-grid gap-2">
        <a class="btn-sm align-items-center btn btn-primary d-flex justify-content-center text-white" href="mailto:${item['offer_link']}">
        E-Mail senden
        </a>
     </div>
  </div>` : `<div class="row mt-3">
     <div class="col-md-12 d-grid gap-2">
        <a class="btn-sm align-items-center btn btn-primary d-flex justify-content-center text-white" target="_balnk" href="${item['offer_link']}">
        Zum Angebot
        </a>
     </div>
  </div>`) : '';

  offer_html += `<div class="swiper-slide swiper-slide-active swiper-slide-duplicate-next swiper-slide-duplicate-prev" style="text-align: left; width: 466px; margin-right: 50px;" data-swiper-slide-index="0">
   <div class="row mt-2">
      <div class="col-12">
        ${offer_percentage}
         <img class="img-fluid br-5" src="/poiimages/${item['image_id']}" style="object-fit: contain; min-height: 200px;">
      </div>
      <div class="col-12">
         <div class="row mt-3">
            <a class="d-flex align-items-center text-decoration-none" href="/entdecken/all/${item['poi_id']}">
               <div class="badge bg-warning br-10 me-2" style="max-width: 90%">
                  <span class="text-truncate">
                  ${item['poi_name']}
                  </span>
               </div>
            </a>
         </div>
         <div class="row mt-3">
            <div class="col-12">
               <h5 class="fw-bold text-left">${item['offer_name']}</h5>
               <hr>
            </div>
         </div>
         <div class="row">
            <div class="col-md-12 d-flex align-items-baseline">
               <h5 class="fw-bold pe-3">${offer_price} €</h5>
               <p class="fs-smaller mb-1">${price_text}</p>
            </div>
            <div class="col-12">
               <hr>
            </div>
         </div>
         <div class="row">
            <div class="col-md-12">
               <span class="fw-bold pe-3 fs-small">Das Angebot ist gültig ab ${ moment(item['show_from']).format("DD.MM.YYYY")}</span>
               <hr>
            </div>
         </div>
         <div class="row">
            <div class="col-md-12">
               <h5 class="fw-bold pe-3">Beschreibung</h5>
               <p class="fs-smaller mb-1">${item['offer_description']}</p>
            </div>
         </div>
         ${offer_link}
      </div>
   </div>
</div>`
  });
  $("#story-modal").modal("show");

  });
  $('#story-modal').on('show.bs.modal', async function (e) {
    $('#story_con').append(offer_html);
    var storyGallery = new Swiper('#story_swiper', {
      modules: [Navigation, Pagination],
      spaceBetween: 50,
      hashNavigation: {
        watchState: true,
      },
      pagination: {
        el: offer_data.length > 1 ? '.swiper-pagination': '',
        clickable: true,
      },
      autoHeight: true,
      loop: offer_data.length > 1 ? true : false
    });
  });
  $("#story-modal").on("hidden.bs.modal", function () {
    $('#story_con').empty();
  });
  $(document).off("click", ".add-to-contact").on("click", ".add-to-contact", function () {
    console.log('click-handler for .add-to-contact');
    const cr = `\r\n`;
    let firstname = $(this).data('firstname') || '';
    let lastname = $(this).data('lastname') || '';
    let organization = $(this).data('organization') || '';
    let file_name = $(this).data('title') || '';
    let file_logo = $(this).data('logo') || '';
    let file_email = $(this).data('email') || '';
    let file_address = $(this).data('address') || ''; // eg:     'Am Römerturm 2;Kaisersesch;;56759'
    let label_val = (file_address.length > 0)
      ? file_address.split(';')[0] + //        'Am Römerturm 2'
        '\r\n' + //                            'Am Römerturm 2\r\n'
        file_address.split(';;')[1] + ' ' + // 'Am Römerturm 2\r\n56759 '
        file_address.split(';')[1] //          'Am Römerturm 2\r\n56759 Kaisersesch'
      : '';
    let file_phone = $(this).data('phone') || '';
    let file_mobile = $(this).data('mobile') || '';

    if (lastname.length > 0 && firstname.length > 0) {
      file_name = '';
    }

    let value__ = `BEGIN:VCARD${cr}` +
                  `VERSION:3.0${cr}`+
                  `N;CHARSET=UTF-8:${lastname};${firstname};;;${file_name}${cr}` +
                  `FN;CHARSET=UTF-8:${file_name}${cr}` +
                  `ORG;CHARSET=UTF-8:${organization}${cr}` +
                  `EMAIL;type=WORK;type=PREF:${file_email}${cr}` +
                  `TEL;type=WORK;VOICE:${file_phone}${cr}` +
                  `TEL;type=FAX;WORK:${file_mobile}${cr}` +
                  `ADR;CHARSET=UTF-8;WORK;type=pref:;;${file_address};${cr}` +
                  `LABEL;WORK;PREF;ENCODING=QUOTED-PRINTABLE;CHARSET=UTF-8:${label_val}${cr}`;

    if (lastname.length > 0 && firstname.length > 0) {
      file_name = $(this).data('title') || '';
    }
    if (file_logo) {
        value__ += `PHOTO;VALUE=URI;TYPE#PNG:${file_logo}\r\n`;
    }
    value__ += `REV:${new Date().toISOString()}${cr}END:VCARD`;

    // completely cast to utf-8
    // since outlook on windows might have conversion-issues when converting umlauts,
    // using the follw. might circumvent this, @see https://stackoverflow.com/a/26301969
    value__= JSON.parse( JSON.stringify( value__ ) );

    let blob = new Blob([value__], { type: 'contentType' });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, `${file_name}.vcf`);
    } else {
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      var icsUrl = URL.createObjectURL(blob);
      a.href = icsUrl;
      a.download = `${file_name}.vcf`;
      a.click();
      URL.revokeObjectURL(a.href)
      a.remove();
    }
  });

  let vimeo_url = $(".vimeo-thumb").first().data("src");
  if (vimeo_url){
    $.getJSON( vimeo_url, function( data ) {
      let vimeo_thumb = data[0]["thumbnail_medium"];
      $(".vimeo-thumb").each(function () {
        $(this).attr("src", vimeo_thumb);
      });
    });
  }
  $("#entdecken_radius_list li").each(function (index) {
    $(this).on("click", function () {
      Turbo.visit('/entdecken?radius=' + $(this).data('radius'), { action: 'replace' })
    });
  });
  $(".poi-radius").click(function () {
    $("#pois-list-filter-modal").modal("hide");
  });
  // offer filters
  $(".offer_index_input_btn").click(function () {
    $('.offer_index_input_search').each(function (index) {
      if ($(this).val() !== '') {
        $("#offers-list-filter-modal").modal("hide");
        Turbo.visit('/marktplatz/offers?search=' + $(this).val(), { action: 'replace' })
        return;
      }
    });
  });
  $('.offer_index_input_search').keypress(function (e) {
    var key = e.which;
    if (key == 13) {
      $('.offer_index_input_btn').click();
      return false;
    }
  });
  $(".offer-radius").click(function () {
    $("#offer-list-filter-modal").modal("hide");
  });
});

document.addEventListener('turbo:render', () => {
  initRadiusSelector();
  initAutoSubmitFields();
});

function initIframeLoad() {
  $('iframe').each(function(index) {
    $(this).contents().find('body').css('font-family', 'sans-serif');
    $(this).contents().find('body').css({
      "background-color": "#f5f5f5",
      "text-align": "center",
      "background-image": "url(/icons/app_logo_watermark.svg)",
      "background-position": "center",
      "background-repeat": "no-repeat"
    });
    let host_name  = get_hostname($(this).attr('data-src'));
    $(this).contents().find('body').html(`<p style='margin-top: 20%; line-height: 1.5;'>
    Dieser Inhalt wird von einer dritten Partei gehostet (<a href='${host_name}' target='_blank' style='color:#f7b624;'>${host_name}</a>).
    Mit dem Anzeigen der externen Inhalte akzeptieren Sie die Bedingungen von <a href='${host_name}' style='color:#f7b624;' target='_blank'>${host_name}</a></p>
    <a style='color: #ffffff;background: #f7b624 ;border: 1px solid #f7b624; padding: 8px; cursor: pointer; border-radius: 5px; text-align: center' id='load_youTube'>
    Externe Inhalte anzeigen</a>`);
    $(this).contents().find('#load_youTube').click(function() {
      load_conten(index);
    });
  });
}
function get_hostname(url) {
    if(url){
      var m = url.match(/^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/?\n]+)/);
      return m ? m[0] : null;
    }
}
function load_conten(index) {
  var i = index;
  var attr = $('iframe')[i].getAttribute('data-src');
  if (typeof attr !== typeof undefined && attr !== false) {
      $('iframe')[i].setAttribute("src", $('iframe')[i].getAttribute('data-src'));
  }
}

async function getPoiList(page_count, category, sort_by_name) {
  const response = await fetch('/load-new-item?page=' + page_count + '&category=' + category + '&radius=' + $("#poi_radius").val() + "&search=" + getUrlParameter('search') + "&sort_by="+ sort_by_name  , {
    // const response = await fetch('/load-new-item?page=' + page_count + '&category=' + category + '&radius=' + $('#poi_radius').val() + "&search=" + $('#event_list_input_search').val(), {
    method: 'get',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  }).then(res => res.clone().json())
  return response;
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return "";
};
